import _ from "lodash";
/** External */
import React, { useState } from "react";
import { connect } from "react-redux";
import { ToggleSwitch } from "@toddle-edu/ds-web";

/** Internal */
import { graphql, compose } from "lib/apolloClient";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import withLoader from "UIComponents/GqlWithLoader";
import { getInternalToolGenericDataQuery } from "InternalTools/modules/InternalToolsQuery";
import {
  CURRICULUM_PROGRAM,
  UNIT_PLANNING_AI,
} from "../../../modules/OrgAddOnContants";
import { updateAddOnStatus } from "../../../modules/OrgAddOnHelpers";

/** Relative */
import classes from "./CurriculumProgramList.scss";

const CurriculumProgramList = ({
  orgId,
  statusMapping,
  updateAddOnStatus,
  curriculumProgramsOfOrg,
  getInternalToolGenericDataVariables,
}) => {
  const [fullScreenLoader, setFullScreenLoader] = useState(false);

  return (
    <div>
      {!_.isEmpty(curriculumProgramsOfOrg) && (
        <div className={classes.parentContainer}>
          <div className={classes.listContainer}>
            {_.map(curriculumProgramsOfOrg, curriculumProgram => {
              const { id, label, acronym } = curriculumProgram;

              const enabledForCurrentCurriculum = _.get(
                statusMapping,
                id,
                false
              );

              const handleCurriculumLevelToggle = async () => {
                setFullScreenLoader(true);
                await updateAddOnStatus({
                  orgId,
                  curriculumId: id,
                  addOnType: UNIT_PLANNING_AI,
                  moduleId: UNIT_PLANNING_AI,
                  updateOn: CURRICULUM_PROGRAM,
                  newStatus: !enabledForCurrentCurriculum,
                  queryVariables: getInternalToolGenericDataVariables,
                });
                setFullScreenLoader(false);
              };

              return (
                <div key={id} className={classes.curriculumProgramItem}>
                  <div>
                    <div>{label}</div>
                    <div
                      className={classes.acronymTypeString}
                    >{`${acronym} - (${id})`}</div>
                  </div>
                  <div className={classes.actionItems}>
                    <ToggleSwitch
                      onChange={handleCurriculumLevelToggle}
                      checked={enabledForCurrentCurriculum}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {fullScreenLoader ? <FullScreenLoader /> : null}
    </div>
  );
};

const mapActionCreators = {
  updateAddOnStatus,
};

const mapStateToProps = (state, ownProps) => {
  const { orgId } = ownProps;

  const getInternalToolGenericDataVariables = {
    input: {
      apiType: "ADD_ON_MANAGER",
      params: {
        organizationId: orgId,
        addOnType: UNIT_PLANNING_AI,
      },
    },
  };

  return {
    isData: true,
    isLoading: false,
    organizationId: orgId,
    getInternalToolGenericDataVariables,
  };
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  graphql(getInternalToolGenericDataQuery, {
    name: "getInternalToolGenericData",
    options: ({ getInternalToolGenericDataVariables }) => ({
      fetchPolicy: "cache-and-network",
      variables: getInternalToolGenericDataVariables,
    }),
    props: ({
      getInternalToolGenericData,
      ownProps: { isData, isLoading },
    }) => {
      const queryData = _.get(
        getInternalToolGenericData,
        "platform.internalToolsGenericQuery",
        {}
      );
      const curriculumPrograms = _.get(
        queryData,
        "data.curriculumPrograms",
        []
      );

      const statusMapping = _.reduce(
        curriculumPrograms,
        (result, curriculumProgram) => {
          const { id, status } = curriculumProgram;
          return {
            ...result,
            [id]: _.get(status, UNIT_PLANNING_AI, false),
          };
        },
        {}
      );

      return {
        statusMapping,
        isData: !_.isEmpty(queryData) && isData,
        isLoading:
          _.includes([1, 2], getInternalToolGenericData["networkStatus"]) ||
          isLoading,
      };
    },
  }),
  withLoader
)(CurriculumProgramList);
